// C:\Users\user\spice_website\frontend\src\hooks\useScrollAnimation.js
import { useRef, useEffect, useState } from 'react';

const useScrollAnimation = (threshold = 0.2) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Optionally, unobserve after it becomes visible if you only want the animation once
         
        }else{
        setIsVisible(false)
    }
      },
      {
        threshold: threshold,
      }
    ); 

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
      observer.disconnect();
    };
  }, [threshold]);

  return [ref, isVisible];
};

export default useScrollAnimation;